import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Admin_Id } from "./Constant";

const CommentSection = ({ slug }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [visibleCount, setVisibleCount] = useState(2);

  const navigate = useNavigate();
  const login = JSON.parse(localStorage.getItem("login")) || null;

  useEffect(() => {
    if (!slug) return;

    fetch(`https://100billionrealestate.com/api/comments/slug/${slug}`)
      .then((res) => res.json())
      .then((data) => setComments(Array.isArray(data) ? data : []))
      .catch((err) => console.error("❌ Error fetching comments:", err));
  }, [slug]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    try {
      const res = await fetch("https://100billionrealestate.com/api/comments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          slug,
          content: newComment,
          author: login?.full_name || login?.email || "Anonymous",
          AdminId: Admin_Id,
        }),
      });

      if (!res.ok) {
        console.error("❌ Server error:", await res.text());
        return;
      }

      const saved = await res.json();
      setComments([saved, ...comments]);
      setNewComment("");
      setVisibleCount((prev) => prev + 1);
    } catch (err) {
      console.error("❌ Failed to post comment:", err.message);
    }
  };

  return (
    <div className="mt-14">
      {/* Section Title */}
      <h3 className="text-lg font-semibold flex items-center gap-2 text-gray-800 mb-4">
        <MessageCircle size={18} />
        Comments ({comments.length})
      </h3>

      {/* Form */}
      <form onSubmit={handleSubmit} className="mb-6 space-y-3">
        <textarea
          rows={3}
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Write your comment..."
          className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
        />
        <button
          type="submit"
          className="px-5 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition"
        >
          Post Comment
        </button>
      </form>

      {/* Comment List */}
      <ul className="space-y-4">
        {comments.slice(0, visibleCount).map((comment, index) => (
          <li key={index} className="p-4 border rounded-md bg-white shadow-sm">
            <div className="flex justify-between items-center text-sm mb-1 text-gray-600">
              <strong>{comment.author || "Anonymous"}</strong>
              <span>{new Date(comment.createdAt).toLocaleString()}</span>
            </div>
            <p className="text-gray-800">{comment.content}</p>
          </li>
        ))}
      </ul>

      {/* View All Button */}
      {comments.length > visibleCount && (
        <button
          onClick={() => navigate(`/blogs/${slug}/comments`)}
          className="mt-4 text-blue-600 hover:underline text-sm font-medium"
        >
          View All Comments
        </button>
      )}
    </div>
  );
};

export default CommentSection;
